import * as React from "react"

const Youtube = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M14.825 5.2c-.175-1.138-.7-1.925-1.925-2.1-1.925-.35-4.9-.35-4.9-.35s-2.975 0-4.9.35c-1.225.175-1.838.962-1.925 2.1C1 6.338 1 8 1 8s0 1.662.175 2.8c.175 1.137.7 1.925 1.925 2.1 1.925.35 4.9.35 4.9.35s2.975 0 4.9-.35c1.225-.263 1.75-.963 1.925-2.1C15 9.662 15 8 15 8s0-1.662-.175-2.8ZM6.25 10.625v-5.25L10.625 8 6.25 10.625Z" />
  </svg>
)

export default Youtube
